import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { ChartCard, TooltipBox } from './AIChartParts'
import { PROVIDER_COLORS, GRID, AXIS_TEXT, num, compact, shortDate, longDate } from './aiCostFormat'

const axisProps = {
  tick: { fill: AXIS_TEXT, fontSize: 12 },
  axisLine: false,
  tickLine: false,
}

const AudioTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null
  const d = payload[0].payload
  return <TooltipBox title={longDate(label)} rows={[{ label: 'Audio minutes', value: num(d.audioMinutes, 1), color: PROVIDER_COLORS.deepgram }]} />
}

/** Deepgram audio minutes per day */
const AIUsageTrendChart = ({ daily = [], isLoading, error }) => (
  <ChartCard
    title="Audio Usage Trend"
    subtitle="Deepgram audio minutes per day"
    isLoading={isLoading}
    error={error}
    isEmpty={!daily.some((d) => d.audioMinutes)}
  >
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={daily} margin={{ top: 8, right: 8, left: 0, bottom: 0 }} barCategoryGap="20%">
        <CartesianGrid vertical={false} stroke={GRID} />
        <XAxis dataKey="date" tickFormatter={shortDate} minTickGap={16} {...axisProps} />
        <YAxis tickFormatter={compact} width={52} {...axisProps} />
        <Tooltip cursor={{ fill: 'rgba(0,0,0,0.04)' }} content={<AudioTooltip />} />
        <Bar dataKey="audioMinutes" name="Audio minutes" fill={PROVIDER_COLORS.deepgram} radius={[4, 4, 0, 0]} maxBarSize={28} />
      </BarChart>
    </ResponsiveContainer>
  </ChartCard>
)

export default AIUsageTrendChart
